/*
 * @Author: Zhouqi
 * @Date: 2026-03-26 15:40:18
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-26 15:51:10
 */
import React from 'react';

import FirstOrderModalContent from '@/components/UI/FirstOrderModal';

import CommonModal from '..';

interface FirstOrderModalShowOptions {
  onClose: () => void;
  onPayEnd: () => void;
  destroyHandle?: { current: () => void };
}

export function firstOrderModalShow(options: FirstOrderModalShowOptions) {
  CommonModal.show(
    (_t) => ({
      width: 'fit-content',
      modalClassName: 'first-order-modal',
      customPadding: { x: 0, y: 0 },
      footer: false,
      requireLogin: false,
      content: (close) => (
        <FirstOrderModalContent
          onClose={() => {
            close();
            options.onClose();
          }}
          onPayEnd={options.onPayEnd}
        />
      ),
    }),
    options.destroyHandle,
  );
}
